import React from "react";
import { Modal, Table } from "antd";

export default function TotalPnlReportsModal({ visible, data, onClose }) {
	const columns = [
		{
			title: "Rasxod turi",
			dataIndex: "acctName",
			key: "acctName",
			render: (text, record) => {
				return (
					<span className={`${text === "Umumiy Chiqimlar" ? "font-extrabold" : ""}`}>{text}</span>
				);
			},
		},
		{
			title: "Summasi",
			dataIndex: "summa",
			key: "summa",
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text).replace(/\s/g, "   ");
				return (
					<span className={`${record?.acctName === "Umumiy Chiqimlar" ? "font-extrabold" : ""}`}>
						{formattedText !== "NaN" ? formattedText : ""}
					</span>
				);
			},
		},
	];

	console.log("Data", data);

	return (
		<Modal
			open={visible}
			onRequestClose={onClose}
			onCancel={onClose}
			style={{
				content: {
					top: "50%",
					left: "50%",
					right: "auto",
					bottom: "auto",
					marginRight: "-50%",
					transform: "translate(-50%, -50%)",
					borderRadius: "10px",
					border: "none",
					padding: "20px",
					backgroundColor: "white",
					outline: "none",
				},
				overlay: {
					background: "#0000008D",
				},
			}}
			contentLabel="Example Modal"
			ariaHideApp={false}
			footer={null}
		>
			<div className={"w-full"}>
				<Table columns={columns} dataSource={data} pagination={false} />
			</div>
		</Modal>
	);
}
